export const queryCheckType = '/erp/check/queryCheckType';
export const queryWebsiteCompany = '/erp/system/queryWebsiteCompany';
export const queryWhetherOpen = '/erp/dic/queryWhetherOpen';
export const updateApproval = '/erp/system/updateApproval';
export const withdrawApply = 'erp/apply/withdrawApply';